import { render, staticRenderFns } from "./ProductsTableCount.vue?vue&type=template&id=6764d59f&"
import script from "./ProductsTableCount.vue?vue&type=script&lang=js&"
export * from "./ProductsTableCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports